import { colors } from '@lmc/common/constants'
import type { SvgType } from './types'

export default function RadioOff({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z"
        stroke={colors.darkgrey}
        fill="none"
      />
    </svg>
  )
}
